import { render } from "./ProfileDetail.vue?vue&type=template&id=717d51ab"
import script from "./ProfileDetail.vue?vue&type=script&lang=js"
export * from "./ProfileDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__